import { render, staticRenderFns } from "./inputsJuvenile.vue?vue&type=template&id=5b15351e&"
import script from "./inputsJuvenile.js?vue&type=script&lang=js&"
export * from "./inputsJuvenile.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports